export const formatPhone = (phone) => phone?.replace(/[^+\d]/g, '');
//# sourceMappingURL=formatPhone.js.map